import LargeBentoGridItem from "@/components/BentoGrid/LargeBentoGridItem";
import SmallBentoGridItem from "@/components/BentoGrid/SmallBentoGridItem";
import ContentWrapper from "@/components/Core/ContentWrapper";
import mq from "@/utils/mq";
import styled, { css } from "styled-components";

const BentoGridWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const GridContainer = styled.div<{ $right?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 24px;
  height: 355px;
  ${mq.mobile(css<{ $right?: boolean }>`
    flex-direction: ${({ $right }) => ($right ? "column-reverse" : "column")};
    height: auto;
  `)};
`;

export default function BentoGrid({ rows }: { rows: any[] }) {
  return (
    <ContentWrapper darkMode transparent>
      <BentoGridWrapper>
        {rows.map((row) => {
          if (row.component === "bentoGridRowLeftLarge") {
            return <GridLeft row={row} />;
          }
          if (row.component === "bentoGridRowRightLarge") {
            return <GridRight row={row} />;
          }
        })}
      </BentoGridWrapper>
    </ContentWrapper>
  );
}

const GridLeft = ({ row }: { row: any }) => {
  return (
    <GridContainer>
      <LargeBentoGridItem item={row.largeBento[0] || []} />
      <SmallBentoGridItem item={row.smallBento[0] || []} />
    </GridContainer>
  );
};

const GridRight = ({ row }: { row: any }) => {
  return (
    <GridContainer $right>
      <SmallBentoGridItem item={row.smallBento[0] || []} />
      <LargeBentoGridItem item={row.largeBento[0] || []} />
    </GridContainer>
  );
};
